import styled from 'styled-components';

import { Textarea } from '@dreryk/react-components';

export const StyledTextarea = styled(Textarea)`
   height: auto;
`;
